@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.textField {
  color: var(--dark-80);
}

.label {
  @include sm-sohne;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  color: var(--dark-40);
}

.inputWrapper {
  @include transition;
  border: 2px solid transparent;
  width: 100%;
  display: flex;
  align-items: center;
  column-gap: 6px;
  box-shadow: 1px 1px 0 0 var(--light-90) inset, 0 2px 12px 0 var(--dark-4);

  &:focus-within {
    border: 2px solid var(--selected-stroke);
  }

  &.error {
    border-color: $red-40;
    background-color: $red-10;
    box-shadow: 0 0 0 3px rgba(237, 132, 126, 0.25);
  }

  [data-autopilot-system-redesign='on'] & {
    box-shadow: none;
    border: 1px solid var(--dark-8);

    &:hover {
      border: 1px solid var(--dark-15);
    }

    &:focus-within {
      border: 1px solid var(--dark-80);
    }

    &.error {
      border: 1px solid var(--red-70);
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.05);
    }
  }
}

.input {
  @include thinScrollbar;

  flex: 1;
  height: 100%;
  // Keep min-height from forcing the input past the wrapper's fixed height, and
  // stay transparent so the input never paints over the wrapper border — in the
  // error state an inherited background would otherwise hide the red border.
  min-height: 0;
  background-color: transparent;

  &::placeholder {
    color: var(--dark-40);
  }
}

.textAreaWrapper {
  min-height: 56px;
  border-radius: 6px;
  padding: 8px 12px;

  .input {
    resize: none;
  }
}

.md {
  .inputWrapper {
    padding: 0 12px;
    border-radius: 4px;
    height: 32px;

    &.withFrontIcon {
      padding: 0 12px 0 10px;
    }
  }

  .input {
    @include sm-sohne;
  }

  [data-autopilot-system-redesign='on'] & {
    .inputWrapper {
      padding: 8px;
    }

    .input {
      @include sm-sohne;
      min-height: 32px;
      height: 32px;
      border-radius: 8px;
      line-height: 130%; /* 18.2px */
      letter-spacing: 0.14px;
    }
  }
}

.lg {
  .inputWrapper {
    height: 40px;
    padding: 0 16px;
    border-radius: 6px;

    &.withFrontIcon {
      padding: 0 16px 0 10px;
    }
  }

  .input {
    @include md-sohne;
  }

  [data-autopilot-system-redesign='on'] & {
    .inputWrapper {
      padding: 8px;
    }

    .input {
      @include md-sohne;
      min-height: 36px;
      height: 36px;
      border-radius: 8px;
      line-height: 145%; /* 23.2px */
      letter-spacing: 0.16px;
    }
  }
}

.xl {
  .inputWrapper {
    height: 48px;
    padding: 0 16px;
    border-radius: 6px;

    &.withFrontIcon {
      padding: 0 16px 0 10px;
    }
  }

  .input {
    @include lg-sohne;
  }

  [data-autopilot-system-redesign='on'] & {
    .inputWrapper {
      padding: 12px 15px;
    }

    .input {
      @include md-sohne;
      height: 48px;
      min-height: 48px;
      border-radius: 10px;
      line-height: 145%; /* 23.2px */
      letter-spacing: 0.16px;
    }
  }
}

.focus {
  .input {
    @include md-sohne;
  }
}

.focus {
  border-color: $grey-50;
}

.error {
  border-color: $red-40;
  background-color: $red-10;
}

.description {
  @include sm-sohne;
  margin-bottom: 8px;
}

.errorMessage {
  @include sm-sohne;
  color: $red-40;
  margin-top: 2px;
  margin-bottom: 8px;
}
.validMessage {
  @include sm-sohne;
  color: var(--positive-50);
  margin-top: 2px;
  margin-bottom: 8px;
}

.select {
  position: relative;

  &:after {
    position: absolute;
    content: ' ';
    top: 14px;
    right: 12px;
    border-right: 1px solid $grey-30;
    border-bottom: 1px solid $grey-30;
    transform: rotate(45deg);
    width: 8px;
    height: 8px;
  }

  .emptySelectField {
    color: $grey-30;
  }
}

@media (min-width: $phoneMaxWidth) {
  .inputWrapper {
    border: 1px solid var(--dark-15);
    box-shadow: none;

    &:focus-within {
      border: 2px solid var(--selected-stroke);
      border: 1px solid transparent;
      box-shadow: 0 0 0 2px var(--selected-stroke);

      [data-autopilot-system-redesign='on'] & {
        border: 1px solid var(--dark-80);
        box-shadow: none;
      }
    }
  }
}
